module.exports = __webpack_public_path__ + "img/withdraw_refused.bba970b3.png";